import { Component, OnInit, Input, HostListener } from '@angular/core';
import { ModalController, LoadingController } from '@ionic/angular';
import {Esupport} from '../../../util/model';
import {EsupportService} from '../utilities/esupport.service';

@Component({
  selector: 'app-esupport',
  standalone:false,
  templateUrl: './esupport.page.html',
  styleUrls: ['./esupport.page.scss'],
})
export class ESupportPage implements OnInit {

  @Input() metricId;
  @Input() institution;
  selected: Esupport = null;
  showCollegeLogo: boolean = true;
  collegeLogo: string | null = null;

  ugMap = new Map<string, Esupport>();

  constructor(
    public modalcontroller : ModalController, 
    private esupportService: EsupportService,
    public loadingController: LoadingController
  ) { }

 ngOnInit() {
    this.openModalPage();
  }
  async openModalPage(){
    const loader = await this.loadingController.create({
      message: "Opening details"
    })
    loader.present();
   this.esupportService.getEsupport( this.institution ).then( r => {
     this.selected = r?.get( this.metricId );
     loader.dismiss();
   });
  /*  const modalState = {
    modal : true,
    desc : 'dummy state modal'
  };
  history.pushState(modalState, null); */
  }
  /* ngOnDestroy() {
    if (window.history.state.modal) {
      history.back();
    }
  } */

  closeModal(){
    this.modalcontroller.dismiss();
  }
}
